// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"3c138684","832":"440953dc"}[chunkId] + ".chunk.js";
};